var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Link } from "@reach/router";
import styled from "styled-components";
export var AnchorLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  text-decoration: none;\n  color: ", ";\n  transition: color ", " ease;\n  cursor: pointer;\n  font-size: 1.4rem;\n  line-height: 1em;\n  font-weight: bold;\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"], ["\n  display: inline-block;\n  text-decoration: none;\n  color: ", ";\n  transition: color ", " ease;\n  cursor: pointer;\n  font-size: 1.4rem;\n  line-height: 1em;\n  font-weight: bold;\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.hoverBg;
});
var templateObject_1;
//# sourceMappingURL=AnchorLink.js.map